import { PartialEnvVarMap } from "../types/envVar";

const productionEnvVars: PartialEnvVarMap = {
  idApiUrl: "https://identity-management.prod.vibe.justworks.com",
  oktaAppClientId: "0oa666b7z4tAsWVyw697",
  oktaHostUrl: "https://login.justworks.com",
  rollbarPostClientToken: "2a6cf4edc90a4e9fa47a837f76143610",
  heapKey: "1234739207",
  heapLocalstorage: false,
  oktaCommonJwGroupId: "00g3jfwzuu1Q2C2kd697",
};

export default productionEnvVars;
